import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { successIconSx } from './Success.style';

export const Success = () => (
  <CheckCircleIcon fontSize="large" sx={successIconSx} />
);
